import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createProductList } from '../actions/ProductListActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import ProductListForm from '../components/ProductListForm';

import Configuration from '../Config';

const validation = Configuration.Validations.productList;
const defaultValues = Configuration.Defaults.createProductList;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CraeteProductList extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createProductList(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/product-lists">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la liste produse
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Lista produse noua
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ProductListForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.productLists.errors.type === 'validation' ? mapValidationErrors(state.productLists.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CraeteProductList);